export enum REFERRAL_SEARCH_PARAMS {
  TAB = 'tab',
  STEP = 'step',
  REF_DEPT_CODE = 'refDeptCode',
  REF_MAG_CODE = 'refMagCode',
  REF_DEPT_ID = 'refDeptId',
  REF_BRANCH_ID = 'refBranchId',
  GUID = 'guid',
}
